import { getRouteApi } from '@tanstack/react-router';
import { useCallback } from 'react';

import { ActivityScreen } from './ActivityScreen';
import type { ActivitySearch } from './activity-search';

const route = getRouteApi('/activity');

export function ActivityRoute() {
  const search = route.useSearch();
  const navigate = route.useNavigate();

  const onSearchChange = useCallback(
    (next: ActivitySearch) => {
      void navigate({
        replace: true,
        search: () => ({
          ...(next.action === undefined ? {} : { action: next.action }),
          ...(next.entity === undefined ? {} : { entity: next.entity }),
          ...(next.entityId === undefined ? {} : { entityId: next.entityId }),
          ...(next.actorUserId === undefined ? {} : { actorUserId: next.actorUserId }),
          ...(next.scope === undefined ? {} : { scope: next.scope }),
          ...(next.cursor === undefined ? {} : { cursor: next.cursor }),
        }),
      });
    },
    [navigate],
  );

  return <ActivityScreen search={search} onSearchChange={onSearchChange} />;
}
